<template>
    <div class="parametre-tables">
        <!-- Vue liste : l'arbre du menu Parametres, integre (pas de navigation). -->
        <div v-if="typparCourant === null" class="panneau-menu">
            <h2>Paramétrage des tables</h2>
            <p class="invite">Choisissez une table à paramétrer.</p>
            <ul class="niveau racine">
                <MenuNoeud v-for="(n, i) in arbre" :key="i" :noeud="n" @ouvrir="ouvrir" @action="faireAction" />
            </ul>
        </div>

        <!-- Vue editeur : la grille de la table choisie, en panneau (Fermer -> retour a la liste). -->
        <div v-else class="panneau-editeur">
            <button class="retour-liste" @click="fermer">← Retour à la liste des tables</button>
            <ParametrageTable :key="typparCourant" :typpar="typparCourant" :embarque="true" @fermer="fermer" />
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import menuParametres from '../../../script/menuParametres.js';
    import MenuNoeud from '../../MenuNoeud.vue';
    import ParametrageTable from '../../ParametrageTable.vue';

    // Panneau "Paramétrage des tables" integre dans l'ecran Parametres (Parametre.vue).
    // Reutilise l'arbre de menu (MenuNoeud) et l'editeur generique (ParametrageTable) sans
    // changer de route : selectionner une table l'ouvre en place ; "Fermer" revient a la liste.
    export default defineComponent({
        components: { MenuNoeud, ParametrageTable },
        data() {
            return {
                arbre: menuParametres,
                typparCourant: null,
            };
        },
        methods: {
            ouvrir(typpar) {
                this.typparCourant = typpar;
            },
            fermer() {
                this.typparCourant = null;
            },
            faireAction(noeud) {
                // Feuilles non-table (imports, MAJ base ref, options...) : stub pour cette iteration.
                alert("Fonction non encore portee : " + noeud.label + " (" + noeud.action + ")");
            },
        },
    });
</script>

<style scoped>
    .parametre-tables { width: 100%; min-width: 0; }
    .panneau-editeur { min-width: 0; }
    h2 { color: #01358D; font-size: 18px; margin: 0 0 6px; }
    .invite { color: #555; margin: 0 0 12px; }
    ul.niveau { display: block; list-style: none; padding-left: 16px; margin: 0; }
    .parametre-tables > .panneau-menu > ul.niveau { padding-left: 0; }
    .retour-liste {
        background: none;
        border: none;
        color: #004AAD;
        cursor: pointer;
        font-size: 14px;
        padding: 0 0 10px;
    }
    .retour-liste:hover { text-decoration: underline; }
</style>
